import { Component, HostListener } from "@angular/core";
import { NotificationRecords } from "../../../classes/domain/entities/website/notificationrecord/notificationrecord";
import { AuthService } from "../../services";
import { Router } from "@angular/router";
import { UIUtils } from "../../../services/uiutils.service";
import { AppStateManageService } from "./../../../services/app-state-manage.service";
import { NotificationManagementService } from "../../../services/notificationmanagement.service";
import { SidebarMenuStateService } from "../../../services/sidebarmenustateservice";
import { CommonModule } from "@angular/common";
import { SharedModalComponent } from "../shared-modal/shared-modal.component";
import { DevextremesharedmoduleModule } from "../../Module/devextremeshared/devextremeshared.module";
import { MarkNotificationAsReadCustomRequest } from "../../../classes/domain/entities/website/notificationrecord/marknotificationasreadcustomrequest";
import { PayloadPacketFacade } from "../../../classes/infrastructure/payloadpacket/payloadpacketfacade";
import { ServerCommunicatorService } from "../../../services/server-communicator.service";
import { Roles, TransactionTypes } from "../../../classes/infrastructure/enums";
import { firstValueFrom } from "rxjs";
import { ScreenSizeService } from "@app/services/screensize.service";

@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
  styleUrl: "./notification.component.scss",
  standalone: true,
  imports: [CommonModule, DevextremesharedmoduleModule],
})
export class NotificationComponent {
  EmployeeRecordRef: number = 0;
  AllNotifications: NotificationRecords[] = []; // full list from the backend
  NotificationList: NotificationRecords[] = []; // only the current page, used by the template
  pageSize: number = 0;
  currentPage = 1;
  isLoading = false;
  hasNextPage = true;
  private lastNotificationCount: number | null = null;
  private notificationCountSub?: any;
  constructor(
    private authService: AuthService,
    private router: Router,
    private uiUtils: UIUtils,
    private appStateManage: AppStateManageService,
    private serverCommunicator: ServerCommunicatorService,
    private payloadPacketFacade: PayloadPacketFacade,
    private sidebarMenuState: SidebarMenuStateService,
    private NotificationManagementService: NotificationManagementService,
    private screenSizeService: ScreenSizeService
  ) {}

  async ngOnInit() {
    this.pageSize = this.screenSizeService.getPageSize("withDropdown", 3) || 10; // default to 10 if undefined  
    
    let logintoken = this.appStateManage.getLoginToken();
    // console.log('logintoken', logintoken);
    if (logintoken) {
      // this.sidebarMenuState.loadLoginUserWiseResponse();
      this.sidebarMenuState.userRef$.subscribe(async (ref) => {
        //
        if (ref) {
          this.EmployeeRecordRef = ref;
          await this.GetNotificationListByEmployeeRecordRefAndPageNumber(
            ref,
            this.currentPage,
          );

          // 🔥 listen for COUNT changes
          this.listenToNotificationCount(ref);
        }
      });
    }


  }
  private listenToNotificationCount(userRef: number) {
    this.notificationCountSub =
      this.NotificationManagementService.getNotificationCount$(
        userRef,
      ).subscribe(async (count) => {
        // 🚫 skip first emission
        if (this.lastNotificationCount === null) {
          this.lastNotificationCount = count;
          return;
        }

        // ✅ only when count changes
        if (count !== this.lastNotificationCount) {
          this.lastNotificationCount = count;
          // this.currentPage = 1;

          await this.GetNotificationListByEmployeeRecordRefAndPageNumber(
            userRef,
            this.currentPage,
          );
        }
      });
  }

  parseBackendDate(dateStr: string): Date {
    const p = dateStr.split("-").map(Number);
    return new Date(p[0], p[1] - 1, p[2], p[3], p[4], p[5], p[6]);
  }

  getTimeLabel(dateStr: string): string {
    const date = this.parseBackendDate(dateStr);
    const now = new Date();

    const diffMs = now.getTime() - date.getTime();
    const diffMin = Math.floor(diffMs / (1000 * 60));
    const diffHr = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDay = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDay === 0) {
      if (diffMin < 1) return "Just now";
      if (diffMin < 60) return `${diffMin} min ago`;
      return `${diffHr} hr ago`;
    }

    if (diffDay === 1) return "Yesterday";
    if (diffDay < 7) return `${diffDay} days ago`;

    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }

  ngOnDestroy() {
    this.notificationCountSub?.unsubscribe();
  }

  // onNotificationClick = async (e: NotificationRecords) => {
  //   debugger
  //   const item = e;
  //   if (item.p.IsRead == false) {
  //     let req = new MarkNotificationAsReadCustomRequest();
  //     req.NotificationRecordRefs.push(item.p.Ref);
  //     let td = req.FormulateTransportData();
  //     let pkt = this.payloadPacketFacade.CreateNewPayloadPacket2(td);
  //     let tr = await this.serverCommunicator.sendHttpRequest(pkt);

  //     if (!tr.Successful) {
  //       await this.uiUtils.showErrorMessage('Error', tr.Message);
  //       return;
  //     }

  //     this.sidebarMenuState.role$.subscribe(async role => {
  //       //
  //       if (role == Roles.AF || role == Roles.Asha && item.p.FromEntityType == TransactionTypes.FamilyRegistration) {
  //         await this.router.navigate(['Family_Registration'], {
  //           state: { fromEntityRef: item.p.FromEntityRef }
  //         });
  //       }
  //       else if (role == Roles.AF && TransactionTypes.EditRequestForm == item.p.FromEntityType) {
  //         await this.router.navigate(["Edit_Request_Form"], {
  //           state: {
  //             fromEntityRef: item.p.FromEntityRef
  //           }
  //         });
  //       }
  //       else if (role == Roles.BCM || role == Roles.DCM && TransactionTypes.EditRequestForm == item.p.FromEntityType) {
  //         await this.router.navigate(["Edit_Request_Approval_Form"], {
  //           state: {
  //             fromEntityRef: item.p.FromEntityRef
  //           }
  //         });
  //       }

  //     });
  //   }
  //   else {
  //     this.sidebarMenuState.role$.subscribe(async role => {
  //       //
  //       if (role == Roles.AF || role == Roles.Asha && item.p.FromEntityType == TransactionTypes.FamilyRegistration) {
  //         await this.router.navigate(['Family_Registration'], {
  //           state: { fromEntityRef: item.p.FromEntityRef }
  //         });
  //       }
  //       else if (role == Roles.AF && TransactionTypes.EditRequestForm == item.p.FromEntityType) {
  //         await this.router.navigate(["Edit_Request_Form"], {
  //           state: {
  //             fromEntityRef: item.p.FromEntityRef
  //           }
  //         });
  //       }
  //       else if (role == Roles.BCM || role == Roles.DCM && TransactionTypes.EditRequestForm == item.p.FromEntityType) {
  //         await this.router.navigate(["Edit_Request_Approval_Form"], {
  //           state: {
  //             fromEntityRef: item.p.FromEntityRef
  //           }
  //         });
  //       }
  //     });
  //   }
  // }

  onNotificationClick = async (e: NotificationRecords) => {
    debugger;
    const item = e;

    // ✅ Mark as read only if unread
    if (item.p.is_read == false) {
      let req = new MarkNotificationAsReadCustomRequest();
      req.notification_record_ids.push(item.p.id);
      let td = req.FormulateTransportData();
      let pkt = this.payloadPacketFacade.CreateNewPayloadPacket2(td);
      let tr = await this.serverCommunicator.sendHttpRequest(pkt);

      if (!tr.Successful) {
        await this.uiUtils.showErrorMessage("Error", tr.Message);
        return;
      }
    }

    // ✅ Get current role instantly (no duplicate subscribe blocks)
    const role = await firstValueFrom(this.sidebarMenuState.role$);

    //  Family Registration → AF (notification sent by ASHA)
    if (
      role == Roles.AF &&
      item.p.from_entity_type == TransactionTypes.FamilyRegistration
    ) {
      await this.router.navigate(["Family_Registration"]);
    }

    //  Edit Request Form → AF
    else if (
      role == Roles.AF &&
      item.p.from_entity_type == TransactionTypes.EditRequestForm
    ) {
      await this.router.navigate(["Edit_Request_Form"], {
        state: { fromEntityRef: item.p.from_entity_id },
      });
    }

    //  Edit Request Approval Form → BCM or DCM
    else if (
      (role == Roles.BCM || role == Roles.DCM) &&
      item.p.from_entity_type == TransactionTypes.EditRequestForm
    ) {
      await this.router.navigate(["Edit_Request_Approval_Form"], {
        state: { fromEntityRef: item.p.from_entity_id },
      });
    }
    if (
      role == Roles.Asha &&
      item.p.from_entity_type == TransactionTypes.FamilyRegistration
    ) {
      await this.router.navigate(["Family_Registration"]);
    }
  };

  // GetNotificationListByEmployeeRecordRefAndPageNumber = async (
  //   ref: number,
  //   pageNo: number,
  // ) => {
  //   this.isLoading = true;
  //   let lst =
  //     await NotificationRecords.FetchEntireListbyEmployeeRecordRefAndPageNumber(
  //       ref,
  //       pageNo,
  //       async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
  //     );
  //   this.NotificationList = lst;
  //   console.log(' this.NotificationList :',  this.NotificationList);

  //   // optional: if backend sends < 50 → no more pages
  //   if (this.NotificationList.length == 0) {
  //     this.hasNextPage = false;
  //   }

  //   this.isLoading = false;
  // };

  GetNotificationListByEmployeeRecordRefAndPageNumber = async (
  ref: number,
  pageNo: number,
) => {
  this.isLoading = true;

  this.AllNotifications =
  await NotificationRecords.FetchEntireListbyEmployeeRecordRefAndPageNumber(
    ref,
    pageNo, // keep whatever you pass today (e.g. 1)
      async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
    );

  // If the list shrank, make sure currentPage is still valid
  const totalPages = this.getTotalPages();
  if (this.currentPage > totalPages) this.currentPage = totalPages;

  this.applyPagination();
  this.isLoading = false;
  console.log(' this.AllNotifications :',  this.AllNotifications);
};

private getTotalPages(): number {
  return Math.max(1, Math.ceil(this.AllNotifications.length / this.pageSize));
}

private applyPagination() {
  const start = (this.currentPage - 1) * this.pageSize;
  const end = start + this.pageSize;

  this.NotificationList = this.AllNotifications.slice(start, end);
  this.hasNextPage = end < this.AllNotifications.length; // exact, no guessing
}


  async nextPage() {
    if (!this.hasNextPage) return;

    this.currentPage++;
    this.applyPagination();
    // await this.GetNotificationListByEmployeeRecordRefAndPageNumber(
    //   this.EmployeeRecordRef,
    //   this.currentPage,
    // );
  }

  async prevPage() {
    if (this.currentPage === 1) return;

    this.currentPage--;

    this.applyPagination();

    // await this.GetNotificationListByEmployeeRecordRefAndPageNumber(
    //   this.EmployeeRecordRef,
    //   this.currentPage,
    // );
    // this.hasNextPage = true;
  }

  @HostListener("window:resize")
onResize() {
  const newSize = this.screenSizeService.getPageSize("withDropdown", 3);
  if (newSize !== this.pageSize) {
    this.pageSize = newSize;
    this.currentPage = 1;
    this.applyPagination();
  }
}

  // Mark as Read Functionality
  markAllAsRead = async () => {
    const unreadItems = this.NotificationList.filter((item) => !item.p.is_read);

    if (unreadItems.length === 0) {
      await this.uiUtils.showErrorMessage(
        "Info",
        "All notifications are already read!",
      );
      return;
    }

    this.uiUtils.showConfirmationMessage(
      "Confirm",
      "Mark all notifications as read?",
      async () => {
        let req = new MarkNotificationAsReadCustomRequest();
        unreadItems.forEach((item) =>
          req.notification_record_ids.push(item.p.id),
        );

        let td = req.FormulateTransportData();
        let pkt = this.payloadPacketFacade.CreateNewPayloadPacket2(td);
        let tr = await this.serverCommunicator.sendHttpRequest(pkt);

        if (!tr.Successful) {
          await this.uiUtils.showErrorMessage("Error", tr.Message);
          return;
        }

        // this.NotificationList.forEach((item) => (item.p.is_read = true));
        this.AllNotifications.forEach((item) => (item.p.is_read = true));
      },
    );
  };

  async BackAsha() {
    await this.router.navigate(["/home"]);
  }
}
